import React from 'react'
import './Alert.css'

const Alert = () => {
  return (
    <div id='alert' style={{display:"none"}}>
      <span>Alert: message</span>
    </div>
  )
}

export default Alert